import React from "react";
import { useFormik } from "formik";
import { Link, useParams } from "react-router-dom";
import SectionHeader from "../../components/SectionHeader";
import { GridInputs, Table } from "../../../../../../components/Functional";
import { FETCH_WAREHOUSE_ITEMS_V2 as fetchWarehouseItemsV2 } from "../../../../../../graphql/query/WarehouseItem";

const Label = props => {
  const { label, widthInPx = 200, disabled = false } = props || {};
  return (
    <div
      title={label}
      className={`overflow-hidden text-ellipsis text-base font-medium leading-5 ${disabled ? "text-gray-400" : "text-black"}`}
      style={{ maxWidth: `${widthInPx}px` }}
    >
      {label}
    </div>
  );
};

const disableConfig = {
  disabled: true,
  inputClassName: "!bg-white !text-gray-400 !border-gray-400",
};

const InstanceWarehouse = props => {
  const { instance } = props || {};
  const { id: instanceId } = useParams();

  const formik = useFormik({
    initialValues: instance,
    enableReinitialize: true,
  });

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "warehouseItemsV2",
    headers: [
      {
        label: "Storage #",
        name: "id",
        type: "custom",
        component: ({ values }) => {
          const isDisabled = values.destroyed === -1;
          return (
            <Link
              className={`${isDisabled ? "pointer-events-auto text-gray-400" : "  underline"}`}
              to={`/warehouse/${values?.id}/details`}
            >
              {values?.id}
            </Link>
          );
        },
      },
      {
        label: "Group",
        name: "mgroup",
        type: "custom",
        component: ({ values }) => (
          <Label label={values.mgroup} disabled={values.destroyed === -1} />
        ),
      },
      {
        label: "Category",
        name: "category.description",
        type: "custom",
        component: ({ values }) => (
          <Label
            label={values.category?.description}
            disabled={values.destroyed === -1}
          />
        ),
      },
      {
        label: "Description",
        name: "description",
        type: "custom",
        component: ({ values }) => (
          <Label
            label={values.itemDescription}
            disabled={values.destroyed === -1}
          />
        ),
      },
      {
        label: "Weight (Kg)",
        name: "weight",
        type: "custom",
        component: ({ values }) => (
          <Label label={values.weight} disabled={values.destroyed === -1} />
        ),
      },
      {
        label: "Dimensions",
        type: "custom",
        component: ({ values }) => (
          <Label
            label={`${values.dimh ?? "00"}L ${values.dimw ?? "00"}W ${
              values.dimd ?? "00"
            }H`}
            disabled={values.destroyed === -1}
          />
        ),
      },
      {
        label: "Container",
        name: "container",
        type: "custom",
        component: ({ values }) => (
          <Label label={values.container} disabled={values.destroyed === -1} />
        ),
      },
      {
        label: "Site",
        type: "custom",
        component: ({ values }) => (
          <Label
            label={values.itemSite?.site?.name}
            disabled={values.destroyed === -1}
          />
        ),
      },
      {
        label: "Location",
        type: "custom",
        component: ({ values }) => (
          <Label
            label={values.itemSite?.location?.description}
            disabled={values.destroyed === -1}
          />
        ),
      },
    ],
    inputs: [],
    FETCH_QUERY: fetchWarehouseItemsV2({
      // WarehouseItem scalar fields
      destroyed: true,
      mgroup: true,
      itemDescription: true,
      weight: true,
      dimh: true,
      dimw: true,
      dimd: true,
      container: true,
      // WarehouseItem associations
      category: {
        description: true,
      },
      itemSite: {
        site: {
          name: true,
        },
        location: {
          description: true,
        },
      },
    }),
    variables: {
      _instance: {
        id: {
          operator: "eq",
          value: instanceId,
        },
      },
    },
    rowClassName: row => {
      return row.destroyed === -1 ? "opacity-50" : "";
    },
    className: "sm:px-0 lg:px-0",
  };

  const inputs = {
    inputs: [
      {
        className:
          "grid grid-cols-1 items-end gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-flow-col lg:grid-cols-4 lg:gap-16",
        inputs: [
          {
            label: "Unpacked Weight",
            name: "unpackedWeight",
            type: "text",
            ...disableConfig,
          },
          {
            label: "Total Weight",
            name: "weight",
            type: "text",
            ...disableConfig,
          },
        ],
      },
    ],
  };

  const detailInputProps = {
    formik,
    ...inputs,
  };

  return (
    <div className="w-full">
      <SectionHeader title="Warehouse" />
      <div className="w-full border-b px-16 py-8">
        <GridInputs {...detailInputProps} />
      </div>
      <div className="flex w-full">
        <div className="flex-1">
          <Table {...tableProps} />
        </div>
      </div>
    </div>
  );
};

export default InstanceWarehouse;
